








import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CalendarPopup extends Vue {
  close() {
    this.$emit('close');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/popup/CalendarPopup.vue